<!-- チェック日時 -->
<template>
  <div class="ticket-checktime">
    <div class="label">
      {{ $t("MyTicketTicketing.checkoutDate") }}:
      <span class="year">{{ displayDateStampedAt }} </span>
      <span class="date">{{ displayTimeStampedAt }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "SFaceCheckinDateTime",
  props: {
    stamped_at: {
      type: String,
    },
  },
  computed: {
    displayDateStampedAt() {
      return this.$moment(new Date(`${this.stamped_at}`)).format("YYYY.MM.DD");
    },
    displayTimeStampedAt() {
      return this.$moment(new Date(`${this.stamped_at}`)).format("HH:mm");
    },
  },
};
</script>

<style lang="scss" scoped>
.ticket-checktime {
  position: fixed;
  bottom: 0;
  width: 100%;
  text-align: center;
  background: black;
  padding: 1vh 0 2.5vh;
  .label {
    color: white;
    padding: 1vh 0;
  }
}
</style>
